import { render, staticRenderFns } from "./travel.vue?vue&type=template&id=9f7fc7fa&scoped=true&"
import script from "./travel.vue?vue&type=script&lang=js&"
export * from "./travel.vue?vue&type=script&lang=js&"
import style0 from "./travel.vue?vue&type=style&index=0&id=9f7fc7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7fc7fa",
  null
  
)

export default component.exports